import "../../../styles/login.css";
import "../../../styles/Register.css";
import useRegister from "./useRegister";
import RegisterLayout from "./RegisterLayout";
import RegisterForm from "./RegisterForm";

export default function RegisterPage() {
  const register = useRegister();

  return (
    <RegisterLayout showSuccess={register.showSuccess}>
      <h2 className="dr-reg-form-title">Register Here</h2>
      <RegisterForm register={register} />

      <div
        className="dr-login-link dr-full"
        onClick={() => (window.location.href = "/")}
      >
        Already have an account? Login
      </div>
    </RegisterLayout>
  );
}
